<button #trigger="matMenuTrigger" [matMenuTriggerFor]="descriptionEmoji" color="accent" mat-icon-button>
    <mat-icon>sentiment_very_satisfied</mat-icon>
</button>
<mat-menu #descriptionEmoji="matMenu" class="emojiMenu">
    <div class="emojiMenuContainer">
        <div class="closeBtn d-flex justify-content-end">
            <button (click)="closeMenu(trigger)" class="medium-icon-button" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <emoji-mart (click)="stopClose($event)" (emojiClick)="addEmoji($event, trigger)"
                    [style]="{ width:'280px' }"
                    emoji="smile" title="Select"></emoji-mart>
    </div>
</mat-menu>
